<template>
    <div>
        <modal
            :is-open="isOpen"
            :is-loading="loading"
            :disabled="loading"
            title="Удалить коллекцию?"
            @onCloseModal="closeModal"
            @onSaveModal="saveModal"
        >
            <div class="app-modal__message mt-20 d-flex">
                <div class="app-modal__icon"></div>
                Внимание! Удаленную коллекцию невозможно восстановить.
            </div>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'
import { mapActions } from 'vuex'

export default {
    name: 'DeleteCollection',
    components: { Modal },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        collectionId: {
            // eslint-disable-next-line
            type: Number | String,
            required: true
        }
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {},
    methods: {
        ...mapActions('supplierCollections', ['deleteCollection']),
        closeModal() {
            this.$emit('closeModal')
        },
        async saveModal() {
            if (this.loading) return

            this.loading = true

            let data = {
                id: this.collectionId
            }

            try {
                await this.deleteCollection(data)

                this.$notify({
                    title: 'Коллекция удалена',
                    type: 'success'
                })

                this.$emit('onDeleteCollection')
            } catch (e) {
                console.log(e)
                this.$notify({
                    title: 'Ошибка',
                    type: 'error'
                })
            }

            this.loading = false
            this.closeModal()
        }
    }
}
</script>
